export enum IMAGE_LOADING_TYPES {
	Eager = 'eager',
	Lazy = 'lazy',
}
